import React from 'react'
import { graphql, HeadProps } from 'gatsby'
import { Layout } from '../../components/Layout'
import { Header } from '../../containers/Header'
import { Footer } from '../../containers/Footer'
import { CommonHead } from '../../components/CommonHead'
import { GatsbySiteMetaData } from '../../app-types'
import { SectionContentInstanceMaraHero } from '../../sections/instances/SectionContentInstanceMaraHero'
import { SectionContentInstanceMaraSignals } from '../../sections/instances/SectionContentInstanceMaraSignals'
import { SectionContentInstanceMaraHowItWorks } from '../../sections/instances/SectionContentInstanceMaraHowItWorks'
import { SectionContentInstanceMaraPerfectMatch } from '../../sections/instances/SectionContentInstanceMaraPerfectMatch'
import { SectionContentInstanceMaraSpecial } from '../../sections/instances/SectionContentInstanceMaraSpecial'
import { SectionContentInstanceMaraMetrics } from '../../sections/instances/SectionContentInstanceMaraMetrics'
import { SectionContentInstanceMaraLogoCarousel } from '../../sections/instances/SectionContentInstanceMaraLogoCarousel'
import { SectionContentInstanceMaraCta } from '../../sections/instances/SectionContentInstanceMaraCta'
import { SectionContentInstanceMaraForPros } from '../../sections/instances/SectionContentInstanceMaraForPros'

interface PageQueryType {
  site: GatsbySiteMetaData
}

export const Head = ({ data, location }: HeadProps<PageQueryType>) => (
  <CommonHead
    title="Mara | A Qwick exclusive AI matching assistant"
    description="Mara is Qwick's AI proprietary matching algorithm purpose built to connect hospitality business with pre-vetted, ready to work hospitality professionals faster and easier when compared to traditional staffing."
    url={data.site.siteMetadata.siteUrl + location.pathname}
  />
)

const Page = () => (
  <Layout header={<Header />}>
    <SectionContentInstanceMaraHero />
    <SectionContentInstanceMaraSignals />
    <SectionContentInstanceMaraHowItWorks />
    <SectionContentInstanceMaraPerfectMatch />
    <SectionContentInstanceMaraSpecial />
    <SectionContentInstanceMaraMetrics />
    <SectionContentInstanceMaraLogoCarousel />
    <SectionContentInstanceMaraCta />
    <SectionContentInstanceMaraForPros />
    <Footer />
  </Layout>
)

export const query = graphql`
  query aiMaraPageQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

export default Page
